import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DelegationService } from '../services/delegation.service';
import { DelegationSliderConstants } from '../delegation-slider-constants';
import { MessageService } from 'primeng/api';
import { DelegationInteractionService } from '../services/delegation-interaction-service';
@Component({
  selector: 'app-delegation-linked-items-panel-list',
  templateUrl: './delegation-linked-items-panel-list.component.html',
  styleUrls: ['./delegation-linked-items-panel-list.component.scss']
})
export class DelegationLinkedItemsPanelListComponent implements OnInit {
  linkedItemDataToDisplay:any;
  linkedItemToBeUnlinked:any;
  indexOfLinkedItemToBeRemoved!:number;
  listOfSelectedDocuments:string[]=[];
  @Output() sendLinkedItemData = new EventEmitter<any>();

  showDeleteLinkedItemsConfirmationModal = false;
  constructor(private delegateService: DelegationService, 
    private messageService: MessageService, 
    private delegationInteractionService: DelegationInteractionService) {
    
   }

  ngOnInit(): void {
    this.delegationInteractionService.closeAndResetDelegateSlider$.subscribe(
      (isClose) => {
        if (isClose) {
          this.linkedItemDataToDisplay=[];
          this.listOfSelectedDocuments=[];
        }
      }
    );
  }

   openDocument(documentNumber: string, version: string)
  {
    var url = location.origin.concat("/eqms.documentDetails/", documentNumber, ":", version);
    window.open(url, "_blank");
  }
  showConfirmationPopupForDeletedAttachments = (linkedItemToDelete:any) => {
    this.linkedItemToBeUnlinked=linkedItemToDelete;
      this.showDeleteLinkedItemsConfirmationModal = true; 
    }
  

  closeConfirmationModal = () => {
    this.showDeleteLinkedItemsConfirmationModal = false;
  }

  getLinkedItems(selecteddocumentsList:string[])
  {
    if( selecteddocumentsList.length<=0)
    {
      this.messageService.add({
        severity: DelegationSliderConstants.Severity_Err,
        summary: `${DelegationSliderConstants.Atleast_One_Linked_Item_Must_Be_Selected_Error_Message}`,
      });
    }
    
    else
    {
      selecteddocumentsList.forEach(element => {
        if(Object.values(this.listOfSelectedDocuments).indexOf(element)>=0)
        {
          this.messageService.add({
            severity: DelegationSliderConstants.Severity_Err,
            summary: `${DelegationSliderConstants.Linked_Item_Already_Exists_Error_Message}`,
          });
        }
        else
        {
          this.listOfSelectedDocuments.push(element);
        }
        });

    let documentListToGetLatest:string[]=[];
    documentListToGetLatest=this.listOfSelectedDocuments;
    this.sendLinkedItemData.emit(documentListToGetLatest);
      this.delegateService.getLatestDocumentDetail(documentListToGetLatest).subscribe((serviceData) => {
        this.linkedItemDataToDisplay = serviceData
      });
    }
}
  updateDelegationData=()=>{    
    this.linkedItemDataToDisplay.forEach((element: { number: any; },index: any) => {
      if(element.number===this.linkedItemToBeUnlinked)
      {
        this.indexOfLinkedItemToBeRemoved=index;
        this.linkedItemDataToDisplay.splice(this.indexOfLinkedItemToBeRemoved,1);
        this.listOfSelectedDocuments.splice(this.listOfSelectedDocuments.indexOf(element.number),1);
      }
    });
   
    this.showDeleteLinkedItemsConfirmationModal = false;
  }  
}
